// extracted by mini-css-extract-plugin
module.exports = {"container":"_1pKwF9YQiADBEkcrIrdSvU","logo":"oN3vZ4t3BrPNW1PK3n5fk","data":"uBpBNfAfb3nsUSBNLowZg","store":"tQpYXHt94NSMsfAJ6g9Vn","verticalBottom":"_3f8L0YPvA5yp3QhilApkIx"};